<div class="modal-header">
  <h4 class="modal-title">{{'labelEditorPopupAssistant.label.title' | translate}}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <div class="row">
      <div class="col-8">
        <div class="row">
          <div class="col-md-5 offset-md-5">
            <label class="col-form-label font-weight-bold">{{'labelEditorPopupAssistant.label.labeling' | translate}}</label>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.label_type' | translate}}:</label>
          <div class="col-md-6">
            <select id="labelType" name="labelType" class="form-control" [(ngModel)]="labelType">
              <option value="alphabetic">{{'labelEditorPopupAssistant.label.label_type_alphabetic' | translate}}</option>
              <option value="numeric">{{'labelEditorPopupAssistant.label.label_type_numeric' | translate}}</option>
            </select>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.from' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="fromText" [inputRestricter]="fromToTextInputPattern" [attr.maxlength]="fromToTextInputMaxChars">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.to' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="toText" [inputRestricter]="fromToTextInputPattern" [attr.maxlength]="fromToTextInputMaxChars">
          </div>
        </div>
        <div class="mb-3 row">
          <!--<label class="col-md-5 col-form-label" >{{'labelEditorPopupAssistant.label.show_leading_zeros' | translate}}:</label>-->
          <label class="col-md-5 col-form-label"></label>
          <div class="col-md-6">
            <div class="form-control form-check">
              <input class="form-check-input" id="showLeadingZeros" type="checkbox" [(ngModel)]="isShowLeadingZeros" [disabled]="!showLeadingZerosEnabled">
              <label class="form-check-label" id="showLeadingZerosLabel" for="showLeadingZeros">{{'labelEditorPopupAssistant.label.show_leading_zeros' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.increment' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="increment" inputRestricter="^[0-9]*$" maxlength="10">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.prefix' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="prefixText">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.suffix' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="suffixText">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.header' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="headerText">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.footer' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="footerText">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.repeat_entry' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="repeatEntry" inputRestricter="^[0-9]*$" maxlength="3">
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">{{'labelEditorPopupAssistant.label.repeat_count' | translate}}:</label>
          <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="repeatCount" inputRestricter="^[0-9]*$" maxlength="3">
          </div>
        </div>
        <div *ngIf="isPENOptionsAvailable">
          <div class="mb-3 row">
            <label class="col-md-5 col-form-label"></label>
            <div class="col-md-6 d-flex">
              <div class="form-control form-check">
                <input class="form-check-input" id="assistantMarkingWithPE" type="checkbox" [(ngModel)]="selectedPENOptions.withPE">
                <label class="form-check-label" for="assistantMarkingWithPE">{{'labelEditorPopup.label.set_marking_with_PE' | translate}}</label>
              </div>
              <select class="form-control smart-font" [(ngModel)]="selectedPENOptions.selectedPESymbol" (change)="onPESymbolChange()">
                <option *ngFor="let option of symbolPEOptions" [value]="option.value">{{option.label}}</option>
              </select>
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-md-5 col-form-label"></label>
            <div class="col-md-6 d-flex">
              <div class="form-control form-check">
                <input class="form-check-input" id="assistantMarkingWithN" type="checkbox" [(ngModel)]="selectedPENOptions.withN">
                <label class="form-check-label" for="assistantMarkingWithN">{{'labelEditorPopup.label.set_marking_with_N' | translate}}</label>
              </div>
              <select class="form-control smart-font" [(ngModel)]="selectedPENOptions.selectedNSymbol" (change)="onNSymbolChange()">
                <option *ngFor="let option of symbolNOptions" [value]="option.value">{{option.label}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="row">
          <label class="col-form-label font-weight-bold">{{'labelEditorPopupAssistant.label.labeling_order' | translate}}</label>
        </div>
        <div class="mb-3 row">
          <span *ngFor="let option of labelingOrderDataProvider">
            <button (click)="labelingOrderButtonClickHandler(event, option)" class="labelingOrderButton" [class.labelingOrderButtonPressed]="option.selected">
              <img src="{{'ng-assets/pics/labeleditor/' + option.icon}}" alt="">
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="cancel()">{{'global.label.cancel' | translate}}</button>
  <button class="btn btn-primary btn-forward" (click)="executeLabeling()">{{'labelEditorPopupAssistant.label.execute_labeling' | translate}}</button>
</div>
